"use client"

import Image from "next/image";

export default function PopupProduct({ item, setIsOpen } : any) {
    const handleClose = () => {
        setIsOpen(false);
    }

    const handleAddToCart = () => {
        setIsOpen(false);
        sessionStorage.setItem('cart', JSON.stringify([...JSON.parse(sessionStorage.getItem('cart') || '[]'), item]));
    }

    const handlePurchaseNow = () => {
        handleAddToCart();
        window.location.href = '/checkout';
    }

    return (
        <div className="dialog dialog--active">
            <div className="dialog__inner">
                <div className="dialog__close">
                    <button className="js-dialog-close" onClick={() => handleClose()}>
                        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="currentColor"/>
                        </svg>
                    </button>
                </div>

                <div className="dialog__image">
                    <Image src={item.image} alt="product" width={100} height={100} />
                </div>

                <div className="dialog__content">
                    <h3>{item.title}</h3>

                    <p>{item.price}лв.</p>
                </div>

                <div className="dialog__actions">
                    <a onClick={handleAddToCart} className="btn dialog__btn">Добави в количка</a>

                    <a onClick={handlePurchaseNow} className="btn btn--outlined dialog__btn">Поръчай сега</a>
                </div>
            </div>
        </div>
    )
}